var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-medium-size-100 md-size-100"},[_c('edit-form',{ref:"edit-form",attrs:{"header-color":"green"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }